import React__default from 'react';
import styles from '../41e3e4ef74b344163f6f9c634823f771533dce8ee2dfa33ad6af214c7fd67517.cfe-internal.js';
import LoadingSpinner from '../../LoadingSpinner/c1d4ab2d80e06d3124a53446eeecc60a6cba52771287066715dd5ead365ec056.cfe-internal.js';

var MenuSpinner = /*#__PURE__*/React__default.forwardRef(function (_, ref) {
  return /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    ref: ref,
    className: styles.menuSpinner,
    show: true,
    size: "small"
  });
});
var MenuSpinner$1 = MenuSpinner;

export { MenuSpinner$1 as default };
